"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global-error.tsx]", error);
  }, [error]);

  return (
    <html lang="pt-BR">
      <body
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          fontFamily: "system-ui, -apple-system, sans-serif",
          background: "#163970",
          color: "#f5f5f5",
        }}
      >
        <div style={{ maxWidth: "32rem", textAlign: "center" }}>
          <p style={{ fontSize: "2.5rem", margin: 0 }}>💥</p>
          <h2 style={{ fontSize: "1.25rem", fontWeight: 700, marginTop: "0.5rem" }}>
            Erro crítico
          </h2>
          <p style={{ fontSize: "0.875rem", opacity: 0.7, marginTop: "0.5rem" }}>
            {error.message || "O app não conseguiu carregar."}
          </p>
          {error.digest && (
            <p
              style={{
                fontSize: "0.75rem",
                opacity: 0.5,
                marginTop: "0.5rem",
                fontFamily: "monospace",
              }}
            >
              ID: {error.digest}
            </p>
          )}
          <button
            onClick={() => reset()}
            style={{
              marginTop: "1rem",
              padding: "0.5rem 1rem",
              background: "#FF6E32",
              color: "#fff",
              border: 0,
              borderRadius: "0.5rem",
              fontSize: "0.875rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Tentar novamente
          </button>
        </div>
      </body>
    </html>
  );
}
